import type { NetworkError } from './api';
import * as Sentry from '@sentry/react';

export interface ErrorLogContext {
  formType?: string;
  endpoint?: string;
  userAgent?: string;
  timestamp?: string;
  additionalData?: Record<string, any>;
}

/**
 * Enhanced error logging with context
 */
export const logNetworkError = (
  error: NetworkError,
  context: ErrorLogContext = {}
) => {
  const errorContext = {
    ...context,
    timestamp: new Date().toISOString(),
    userAgent: navigator.userAgent,
  };

  // Sentry logging with enhanced context
  Sentry.captureException(error.originalError || error, {
    tags: {
      errorType: error.type,
      statusCode: error.statusCode?.toString() || 'unknown',
      formType: context.formType || 'unknown',
      endpoint: context.endpoint || 'unknown'
    },
    extra: {
      networkError: error,
      context: errorContext
    }
  });
};

/**
 * Check if error is retryable
 */
export const isRetryableError = (error: NetworkError): boolean => {
  switch (error.type) {
    case 'network':
    case 'timeout':
    case 'server':
      return true;
    case 'client':
    case 'rate-limit':
    case 'unknown':
    default:
      return false;
  }
};